import { JobDocumentEntityType } from "@/lib/supabase/supabaseTypes";
import { PdfTemplateType } from "../pdf-templates/document-template.types";

// Create a base template that can be reused
const createBaseJobDocument = (
	title: string,
	type: string
): JobDocumentEntityType => ({
	id: 1341,
	created_at: "2024-02-18 20:14:36.056809+00",
	modified_at: "2024-02-18 20:14:36.056809+00",
	title,
	created_by: null,
	modified_by: null,
	job_id: 1856,
	type,
	type_data: null,
	status: 1,
	amount: null,
	date: "2024-02-18",
	discount_material: 10,
	discount_work: 20,
	fae_id: null,
	code: null,
	work_title: "Test Job",
	deleted_at: null,
	note: "Dies ist ein Beispiel für eine Notiz",
});

export const jobDocumentExample: Record<
	PdfTemplateType,
	JobDocumentEntityType
> = {
	[PdfTemplateType.KOSTENVORANSCHLAG]: createBaseJobDocument(
		"Kostenvoranschlag",
		"qt"
	),
	[PdfTemplateType.LIEFERSCHEIN]: createBaseJobDocument("Lieferschein", "dm"),
	[PdfTemplateType.RECHNUNG]: createBaseJobDocument("Rechnung", "rg"),
	[PdfTemplateType.RECHNUNGSDOPPEL]: createBaseJobDocument(
		"Rechnungsdoppel",
		"rg_doppel"
	),
	[PdfTemplateType.ZAHLUNGSERINNERUNG]: createBaseJobDocument(
		"Zahlungserinnerung",
		"zahlungsrinnerung"
	),
	[PdfTemplateType.ERSTE_MAHNUNG]: createBaseJobDocument(
		"Erste Mahnung",
		"mahnung_1"
	),
	[PdfTemplateType.FOLGEMAHNUNG]: createBaseJobDocument(
		"Folgemahnung",
		"mahnung_2"
	),
	[PdfTemplateType.LETZTE_MAHNUNG]: createBaseJobDocument(
		"Letzte Mahnung",
		"letzte_mahnung"
	),
	[PdfTemplateType.BARZAHLUNGSQUITTUNG]: createBaseJobDocument(
		"Barzahlungsquittung",
		"bar"
	),
	[PdfTemplateType.KARTENZAHLUNGSQUITTUNG]: createBaseJobDocument(
		"Kartenzahlungsquittung",
		"karte"
	),
	[PdfTemplateType.AKONTORECHNUNG]: createBaseJobDocument(
		"Akontorechnung",
		"akonto"
	),
	[PdfTemplateType.GUTSCHRIFT]: createBaseJobDocument("Gutschrift", "gs"),
	[PdfTemplateType.AUFTRAGSBLATT]: createBaseJobDocument(
		"Auftragsblatt",
		"auftragsblatt"
	),
	[PdfTemplateType.ETIK_AUFTRAG]: createBaseJobDocument(
		"Auftragsetikett",
		"etik_auftrag"
	),
	[PdfTemplateType.SAMMELRECHNUNG]: createBaseJobDocument(
		"Sammelrechnung",
		"srg"
	),
};
